import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { Equipment } from 'src/app/models/maintenance/equipment';
import { DeviceForm, DeviceTraccar } from 'src/app/models/traccar/device-traccar';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { CombosConfiguration, HttpService, MessageService } from 'brainloper-ui';
import { kmhToKnots, knotsToKmh } from 'src/app/utils/speed-converter';

@Component({
    selector: 'app-modal-add-devices',
    templateUrl: './modal-add-devices.component.html',
    styleUrls: ['./modal-add-devices.component.scss'],
    standalone: false
})
export class ModalAddDevicesComponent implements OnInit {

  devicesForm: UntypedFormGroup;
  selectEquipment: Equipment;

  reloadComboEquipment = new EventEmitter<any>()
  combosConfigEquipment: CombosConfiguration

  reloadComboUsers = new EventEmitter<any>();
  combosConfigUsers: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'id',
    urlCombo: EndpointDictionary.userEntryRecord.USER_ENTRY_RECORD_COMBO,
    urlParams: [],
    label: 'Encargado',
    selected: 0,
  };

  constructor(
    private message: MessageService,
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<ModalAddDevicesComponent>,
    private http: HttpService,
    @Inject(MAT_DIALOG_DATA) public data: DeviceTraccar,
  ) {
    this.combosConfigEquipment = {
      visibleField: 'code',
      selectionField: 'id',
      urlCombo: EndpointDictionary.Equipment.EQUIPMENT_COMBO,
      label: 'Equipo',
      urlParams: [
        { id: "onlyEquipmentWithoutDevice", value: true },
        { id: "includeEquipments", value: JSON.stringify(this.data?.attributes?.equipmentId ? [this.data.attributes.equipmentId] : []) }
      ],
    }
    this.devicesForm = this.formBuilder.group({
      userId: null,
      name: '',
      uniqueId: '',
      equipmentId: null,
      phone: '',
      model: '',
      speedLimit: [80], // Siempre en km/h en la interfaz
      totalDistance: 0,
    });

  }

  ngOnInit(): void {
    if (this.data) {
      this.initForm();
    }
  }

  async initForm() {
    const speedLimitInKnots = this.data?.attributes?.speedLimit || kmhToKnots(80);
    const speedLimitInKmh = Math.round(knotsToKmh(speedLimitInKnots));

    let odometerValue = this.data?.totalDistance ? Math.floor(this.data.totalDistance) : null;

    if (this.data?.attributes?.equipmentId && !this.data?.totalDistance) {

      // Obtener el equipo para usar su currentOdometer como valor por defecto
      const equipment = await this.http.getDataBody<Equipment>(`${EndpointDictionary.Equipment.CRUD_EQUIPMENT_DATA}/${this.data.attributes.equipmentId}`);
      if (equipment && equipment.currentOdometer) {
        odometerValue = Math.floor(equipment.currentOdometer);
      }
    }

    this.devicesForm = this.formBuilder.group({
      userId: [this.data?.attributes?.userId],
      name: [this.data?.name],
      uniqueId: [this.data?.uniqueId],
      equipmentId: [this.data?.attributes?.equipmentId],
      phone: [this.data?.phone],
      model: [this.data?.model],
      speedLimit: [speedLimitInKmh], // Mostrar en km/h
      totalDistance: [odometerValue],
    });

    this.combosConfigUsers.selected = this.data?.attributes?.userId;
    this.combosConfigEquipment.selected = this.data?.attributes?.equipmentId;
    this.reloadComboEquipment.emit("selected")
    this.reloadComboUsers.emit("selected")
  }

  selectEquipmentId(equipment: Equipment) {
    this.devicesForm.get('userId').setValue(equipment.userId);
    this.devicesForm.get('name').setValue(equipment.code);
    this.devicesForm.get('totalDistance').setValue(Math.floor(equipment.currentOdometer || 0));
    this.combosConfigUsers.selected = equipment.userId;
    this.reloadComboUsers.emit("selected")
  }

  async saveDevices(diveces: DeviceForm) {
    this.message.openLoading("Cargando...", "Guardando dispositivo");

    const speedLimitInKnots = kmhToKnots(diveces.speedLimit || 0);

    var device: DeviceTraccar = {
      id: this.data?.id,
      name: diveces.name,
      uniqueId: diveces.uniqueId,
      status: 'offline',
      disabled: false,
      lastUpdate: new Date(),
      positionId: 0,
      groupId: 0,
      phone: diveces.phone,
      model: diveces.model,
      contact: '',
      category: '',
      totalDistance: Math.floor(diveces.totalDistance || 0),
      attributes: {
        equipmentId: diveces.equipmentId,
        userId: diveces.userId,
        speedLimit: speedLimitInKnots // Guardar en nudos como requiere Traccar
      },
    }

    if (this.data) {
      await this.http.putDataBody<GenericResponse>(`${EndpointDictionary.Traccar.DEVICES}/${device.id}`, device)
    } else {
      await this.http.postDataBody<GenericResponse>(EndpointDictionary.Traccar.DEVICES, device)
    }
    this.message.closeLoading();
    this.dialogRef.close(this.devicesForm.value);
  }

  errorMessage() {
    this.message.Error('Error!', 'Debe completar los campos del formulario');
  }

}
